<script lang="ts">
	export let date: Date;

	const formattedDate = new Intl.DateTimeFormat('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric'
	}).format(date);

	let className = '';
	export { className as class };
</script>

<time datetime={date.toISOString()} class={className}>
	{formattedDate}
</time>
